import { TextBox } from '@apply/components';
import { useExperienceAddressStreet1 } from '../../../../fields/ExperienceFields';

interface ExperienceStreetAddress1Props {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
    validator?: React.ReactNode;
}

export const ExperienceStreetAddress1: React.FC<ExperienceStreetAddress1Props> = ({
    experienceId,
    required = false,
    readOnly = false,
    validator,
}) => {
    const label = 'Street Address ';
    const [streetAddress1, set_streetAddress1] = useExperienceAddressStreet1(experienceId);

    return (
        <>
            <TextBox
                id='experienceStreetAddress1'
                value={streetAddress1}
                onChange={(value) => set_streetAddress1(value)}
                label={label}
                required={required}
                width='100%'
                readOnly={readOnly}
                maxLength={50}
                validator={validator}
            />
        </>
    );
};
